import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

require('./bootstrap');
import Vue from "vue";
import store from "./store";
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import Tooltip from "./cms/directives/tooltip";
import filterPrice from "./utils/filters/price";
import filterTimeOptionShortTitle from "./utils/filters/filterTimeOptionShortTitle";
import VueTheMask from "vue-the-mask";
import VueNotification from "vue-notification";
import NProgress from "nprogress";
import filterTime from "./utils/filters/time";
import ClickOutside from "./utils/directives/ClickOutside";
import { VueReCaptcha } from 'vue-recaptcha-v3'

/**
 * Find all the vue page components and register them globally
 */
const requireComponent = require.context(
    './views',
    true,
    /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
        camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
});

// Filters
Vue.filter('filterPrice', filterPrice);
Vue.filter('filterTime', filterTime);
Vue.filter('filterTimeOptionShortTitle', filterTimeOptionShortTitle);

// Directives
Vue.directive('tooltip', Tooltip);
Vue.directive('click-outside', ClickOutside);

Vue.component('owl-carousel',
    require('vue-owl-carousel')
);

Vue.use(VueNotification);
Vue.use(VueTheMask);



Vue.use(VueReCaptcha, { siteKey: window.application.recaptchaSiteKey, loaderOptions: {
        useRecaptchaNet: true
    } })

Vue.prototype.$mixTableTimeOptions = window.application.mixTableTimeOptions;
Vue.prototype.$eventTableTimeOptions = window.application.eventTableTimeOptions;
Vue.prototype.$mixFareharborMode = window.application.mixFareharborMode;
Vue.prototype.$recaptchaSiteKey = window.application.recaptchaSiteKey;

new Vue({
    el: '#app',
    store
});

// Calculating diagonal strength value for sections
['load', 'resize'].forEach(function (e) {
    window.addEventListener(e, function (event) {
        let diagonalStrength = document.body.clientWidth / 6.54545454;
        document.documentElement.style.setProperty('--diagonal-strength', diagonalStrength + 'px');
    });
});

window.onload = (event) => {
   const links = document.getElementsByClassName('navLink');
   for(let i = 0; i < links.length; i++) {
       if(links[i].href && links[i].href.indexOf('fareharbor') !== -1 && window.FH) {
           const urlSearchParams = new URLSearchParams(links[i].href);
           try {
               const params = Object.fromEntries(urlSearchParams.entries());

               let flow = params.flow !== undefined ? params.flow : '';
               const fareHarborModalObject = { shortname: 'bikerentnyc', fallback: 'simple', fullItems: 'yes', view: 'items' }
               if(flow) {
                   fareHarborModalObject.flow = flow;
               }

               links[i].addEventListener('click', function(e){
                   e.preventDefault();
                   FH.open(fareHarborModalObject)
               });

           } catch (e) {
              console.error(e);
           }
       }
   }
};

window.addEventListener('DOMContentLoaded', async function() {

    // Preloader
    document.getElementById('preloader').classList.add('ready');

    NProgress.start();
    // Initializing application's store
    await store.dispatch('app/init');
    NProgress.inc(0.16);

    if (store.getters['app/locations'].length === 0) {
        await store.dispatch('app/fetchLocations');
        NProgress.inc(0.16);
    }

    if (store.getters['app/bikes'].length === 0) {
        await store.dispatch('app/fetchBikes');
        NProgress.inc(0.16);
    }

    if (store.getters['app/bikesNotLocation'].length === 0) {
        await store.dispatch('app/fetchBikesNotLocation');
        NProgress.inc(0.16);
    }

    if (store.getters['app/types'].length === 0) {
        await store.dispatch('app/fetchTypes');
        NProgress.inc(0.16);
    }

    if (store.getters['app/tours'].length === 0) {
        await store.dispatch('app/fetchTours');
        NProgress.inc(0.16);
    }

    if (store.getters['app/products'].length === 0) {
        await store.dispatch('app/fetchProducts');
        NProgress.inc(0.16);
    }

    if (store.getters['app/timeOptions'].length === 0) {
        await store.dispatch('app/fetchTimeOptions');
        NProgress.inc(0.16);
    }

    NProgress.done();

});
